import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from "../../components/layout/Footer";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import { faqsData } from "../../utils/faqsData";
import * as Animate from "react-reveal";

const QuickNavigationLink = ({ linkName, linkUrl }) => {
  return (
    <Link
      to={`/faqs/${linkUrl}`}
      className="quic-nav-link-item text-sm text-primary rounded-full font-mono bg-primary-light px-4 py-1 mx-3 mb-4"
    >
      {linkName}
    </Link>
  );
};

const FaqLink = ({
  linkId = 1,
  linkIcon,
  linkName,
  linkUrl,
  linkDesc,
  grid,
}) => {
  return (
    <Link to={`/faqs/${linkUrl}`}>
      <div
        className={`faq-grid-item-${
          linkId % 2 === 0 ? "even" : "odd"
        } rounded-xl px-8 py-8 h-96 flex flex-col justify-between`}
      >
        <div className="self-end">
          <img src={linkIcon} width="60rem" alt="" />
        </div>

        <div className="pb-10 pt-12 md:pt-4">
          <h4 className="text-primary font-mono text-xl font-semibold pb-4">
            {linkName}
          </h4>
          <p className="text-default text-sm-15 md:text-base leading-7">
            {linkDesc}
          </p>
        </div>
      </div>
    </Link>
  );
};
const Faqs = () => {
  return (
    <div className="">
      <Helmet>
        <title>Utiva | Frequently Asked Questions</title>
      </Helmet>

      <header className="relative pb-8 md:pb-28 text-center">
        <HeaderNavigation />
        <div className="pt-20 container mx-auto px-4">
          <Animate.Fade bottom>
            <p className="capitalize tracking-widest text-gray pb-4 text-sm md:text-base">
              FREQUENTLY ASKED QUESTIONS 🤔
            </p>

            <h2 className="text-2xl md:text-3xl lg:text-4xl text-primary font-mono font-semibold pb-4">
              We know you’ve got some questions
            </h2>
          </Animate.Fade>
        </div>
      </header>
      <section className=" pt-6 pb-10 text-center">
        <div className="container mx-auto px-4">
          <Animate.Fade bottom>
            <p className="capitalize tracking-widest text-gray text-sm pb-4">
              QUICK NAVIGATION
            </p>

            <div className="pt-3 pb-8 relative flex flex-wrap justify-center">
              <QuickNavigationLink linkName="About Us" linkUrl="about" />
              <QuickNavigationLink
                linkName="Learning Model"
                linkUrl="learning-model"
              />
              <QuickNavigationLink linkName="Payment" linkUrl="payment" />

              <QuickNavigationLink
                linkName="Partnership"
                linkUrl="partnership"
              />

              <QuickNavigationLink
                linkName="Certificate"
                linkUrl="certificate"
              />
            </div>
          </Animate.Fade>
        </div>
      </section>

      <section className="faq-grid-section mt-0 md:mt-10 mb-24 md:mb-48">
        <div className="container mx-auto px-4">
          <div className="faq-grid-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-6">
            <Animate.Fade bottom>
              {faqsData?.map((faq) => (
                <FaqLink
                  index={faq.id}
                  linkId={faq.id}
                  linkUrl={faq.url}
                  linkName={faq.name}
                  linkIcon={faq.icon}
                  linkDesc={faq.description}
                />
              ))}
            </Animate.Fade>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Faqs;
